<template>
<div class="p-relative h-100 w-100">
  <h2 class="d-md-none mobile-section-title">INFORMATION</h2>
  <div class="container pt-6 pl-6 pt-md-5">
    <div class="py-md-4">
    </div>
    <div class="d-md-none">
      <h3 class="text-right f5">
        ル シヤージュ
      </h3>
      <b-row>
        <b-col cols="5">
          <dl class="mt-2">
            <dt>
              【OPEN】
            </dt>
            <dd class="h4">
              11:00~19:00
            </dd>
          </dl>
        </b-col>
        <b-col cols="7">
          <dl class="mt-2">
            <dt>
              【CLOSE】
            </dt>
            <dd class="h6">
              <span class="h4">不定休</span>
              <div class="mt-2 text-secondary">
                店休日はSNS等で事前に<br>
                お知らせ致します
              </div>
            </dd>
          </dl>
        </b-col>
      </b-row>
      <dl class="" style="margin-top: -1rem;">
        <dt class="">
          【TEL】
        </dt>
        <dd class="h4">
          075-752-2018
        </dd>
        <dt class="mt-3">
          【MAIL】
        </dt>
        <dd>
          yonekura@lesillage-kyoto.com
        </dd>
        <dt class="mt-3">
          【ADDRESS】
        </dt>
        <dd>
          〒605-0034<br>
          京都市東山区中之町205-2 WILLPARK神宮 1F
        </dd>
      </dl>
      <b-embed
        type="iframe"
        aspect="16by9"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d478.95697633146597!2d135.78460616842028!3d35.00938172276057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x600109ceb375a50f%3A0x1b49a73ef35e5111!2sLE%20SILLAGE%20FRAGRANCE%20SHOP%20KYOTO!5e0!3m2!1sja!2sjp!4v1605576277039!5m2!1sja!2sjp"
        allowfullscreen
      ></b-embed>

    </div>
    <div class="d-none d-md-block">
      <h2 class="font-size-2_5rem tracking-1 text-center d-none d-md-block">INFORMATION</h2>
      <p class="h5 text-center mt-4">【 LE SILLAGE / ル シヤージュ 】</p>
      <div class="row justify-content-center mt-4">
        <div class="col-12 col-lg-8 col-xl-6">
          <img class="img-fluid" src="@/assets/images/shop.jpg">
        </div>
      </div>
    </div>
  </div>
  
</div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>

</style>